import { atom } from 'recoil';

export const refreshCoverableChangesSelectorAtom = atom<object>({
    key: 'refreshCoverableChangesSelectorAtom',
    default: {}
});
